import React from "react";
import "./ContextBox.css";
import UserDropdown from "./users/UserDropdown";

const ContextBox = ({ contextValue, onChangeContext }) => {
    const contextOptions = [
        { value: "resumo_paciente", label: "Resumo do Paciente" },
        { value: "gestao_leitos", label: "Gestão de Leitos" },
        { value: "duvidas_gerais", label: "Dúvidas Gerais" },
    ];

    contextValue = contextValue.trim() !== "" ? contextValue : "duvidas_gerais";

    if (contextValue !== "resumo_paciente") {
        contextOptions.splice(0, 1);
    }

    return (
        <div className="col-12 d-flex justify-content-between align-items-center responsive-top-spacing">
            <div className="d-flex align-items-center">
                <select
                    style={{ color: 'black' }}
                    className="select-context"
                    value={contextValue}
                    onChange={(e) => onChangeContext(e.target.value)}
                >
                    {contextOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
            <div>
                <UserDropdown isInsideContextBox={true} />
            </div>
        </div>
    );
};

export default ContextBox;
